/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errorfallbackdescription2Inputs */



/**
* | output |
* | --- |
* | "There may be too many users for our servers to handle right now. We're already on it — try restarting or updating the app, or reach out to us:" |
*
* @param {Errorfallbackdescription2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const errorfallbackdescription2 = /** @type {((inputs?: Errorfallbackdescription2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errorfallbackdescription2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("There may be too many users for our servers to handle right now.\n\nWe're already on it — try restarting or updating the app, or reach out to us:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puede que ahora mismo haya demasiados usuarios para nuestros servidores.\n\nYa estamos en ello: prueba a reiniciar o actualizar la app, o escríbenos:")
	return /** @type {LocalizedString} */ ("Возможно, пользователей так много, что наши сервера не выдерживают.\n\nМы уже решаем проблему, попробуй перезапустить или обновить приложение, или напиши нам:")
});
export { errorfallbackdescription2 as "errorFallbackDescription" }